import { useEffect, useState } from "react";

const KEY = "grcom_lang";
const EVT = "grcom-lang";

const EN = {
  "Layanan": "Services",
  "Jangkauan": "Coverage",
  "Profil": "Profile",
  "Penawaran": "Get a Quote",
  "IT Support & Infrastruktur": "IT Support & Infrastructure",
  "Perusahaan Infrastruktur IT untuk Bisnis Anda": "IT Infrastructure Company for Your Business",
  "hero_desc": "provides hardware procurement, networking, servers, and trusted IT support for companies across Indonesia.",
  "Distributor & Principal Resmi": "Authorized Distributors & Principals",
  "Kantor Pusat": "Head Office",
  "Layanan Kami": "Our Services",
  "Solusi IT Menyeluruh": "End-to-End IT Solutions",
  "Pengadaan, instalasi, dan pemeliharaan infrastruktur server perusahaan.": "Procurement, installation, and maintenance of enterprise server infrastructure.",
  "Perangkat jaringan, firewall, dan solusi keamanan siber terintegrasi.": "Network devices, firewalls, and integrated cybersecurity solutions.",
  "Perangkat IT & Lisensi": "IT Hardware & Licensing",
  "Laptop, workstation, dan lisensi software resmi dengan harga kompetitif.": "Laptops, workstations, and genuine software licenses at competitive prices.",
  "Dukungan teknis on-site & remote untuk operasional yang selalu berjalan.": "On-site & remote technical support to keep your operations running.",
  "Klien Kami": "Our Clients",
  "Dipercaya Perusahaan Nasional": "Trusted by National Companies",
  "Mitra Kami": "Our Partners",
  "Partner Teknologi": "Technology Partners",
  "Butuh penawaran cepat?": "Need a quick quotation?",
  "Sampaikan kebutuhan Anda. Tim AI Admin kami menyusun penawaran harga terbaik dan menghubungi Anda.": "Tell us what you need. Our AI Admin team prepares the best quotation and gets back to you.",
  "Ajukan Permintaan": "Submit a Request",
  // Request page
  "Kembali ke Beranda": "Back to Home",
  "Permintaan Penawaran Harga": "Quotation Request",
  "Minta Penawaran Barang & Jasa IT": "Request a Quote for IT Products & Services",
  "Sampaikan kebutuhan Anda (laptop, server, networking, jasa IT). Tim kami akan menyusun penawaran harga terbaik dan menghubungi Anda.": "Tell us your needs (laptops, servers, networking, IT services). Our team will prepare the best quotation and contact you.",
  "Jangkauan Nasional": "Nationwide Coverage",
  "Tim CV GRCom Tersebar di Seluruh Indonesia": "CV GRCom Teams Across Indonesia",
  "Tim kami siap mendukung infrastruktur IT perusahaan Anda di mana pun berada.": "Our team is ready to support your company's IT infrastructure wherever you are.",
  "Medan, Sumatera Utara": "Medan, North Sumatra",
  "Permintaan Terkirim!": "Request Sent!",
  "Nomor referensi Anda:": "Your reference number:",
  "akan segera memproses dan menghubungi Anda.": "will process it and contact you shortly.",
  "Tim": "The",
  "team": "team",
  "Kirim Permintaan Lain": "Send Another Request",
  "Nama Anda *": "Your Name *",
  "Perusahaan": "Company",
  "Telepon / WhatsApp": "Phone / WhatsApp",
  "Detail Kebutuhan *": "Requirement Details *",
  "Contoh: 10 unit laptop Lenovo ThinkPad E14 Gen 5 (16GB/512GB) untuk kantor cabang.": "Example: 10 units of Lenovo ThinkPad E14 Gen 5 (16GB/512GB) laptops for a branch office.",
  "Nama dan detail kebutuhan wajib diisi.": "Name and requirement details are required.",
  "Mengirim…": "Sending…",
  "Kirim Permintaan": "Send Request",
  "Samudra Hindia": "Indian Ocean",
  "Samudra Pasifik": "Pacific Ocean",
  "Laut Cina Selatan": "South China Sea",
  "Laut Jawa": "Java Sea",
  "Laut Sulawesi": "Celebes Sea",
  "Laut Banda": "Banda Sea",
  "Laut Flores": "Flores Sea",
  "Laut Arafura": "Arafura Sea",
  // Chat
  "Chat Nadia di sini": "Chat with Nadia",
  "Halo! Isi data singkat agar Nadia dapat mengirimkan penawaran kepada Anda.": "Hello! Fill in a few details so Nadia can send you a quotation.",
  "Email atau No. WhatsApp *": "Email or WhatsApp No. *",
  "Perusahaan (opsional)": "Company (optional)",
  "Gagal memulai chat": "Failed to start chat",
  "Menghubungkan…": "Connecting…",
  "Mulai Chat": "Start Chat",
  "Gagal mengirim rating": "Failed to send rating",
  "Terima kasih atas penilaian Anda!": "Thank you for your rating!",
  "Mulai chat baru": "Start a new chat",
  "Bagaimana pelayanan Nadia hari ini?": "How was Nadia's service today?",
  "Saran atau komentar (opsional)": "Suggestions or comments (optional)",
  "Kirim Rating": "Send Rating",
  "Kembali ke percakapan": "Back to conversation",
  "Buka dokumen": "Open document",
  "Tim kami sedang mengetik…": "Our team is typing…",
  "Menunggu balasan…": "Waiting for reply…",
  "Tulis pesan…": "Type a message…",
  "Selesai & beri rating": "Finish & rate",
  "CS & Intake — biasanya membalas dalam 1 menit": "CS & Intake — usually replies within 1 minute",
  "Hubungi Nadia lewat:": "Contact Nadia via:",
  "Lanjutkan percakapan Anda": "Continue your conversation",
  "Langsung di halaman ini": "Right on this page",
  "Buka di aplikasi Telegram": "Open in the Telegram app",
  "Kirim formulir": "Send a form",
  "Telegram segera hadir": "Telegram coming soon",
  "Nadia offline": "Nadia offline",
  "Nadia sedang offline": "Nadia is offline",
  "Chat aktif Senin–Jumat, 08.00–17.00 WIB.": "Chat is available Mon–Fri, 08:00–17:00 (GMT+7).",
  "Kirim permintaan penawaran": "Send a quotation request",
};

export const getLang = () => localStorage.getItem(KEY) === "en" ? "en" : "id";

export function useLang() {
  const [lang, setLangState] = useState(getLang);
  useEffect(() => {
    const on = () => setLangState(getLang());
    window.addEventListener(EVT, on);
    return () => window.removeEventListener(EVT, on);
  }, []);
  const setLang = (l) => { localStorage.setItem(KEY, l); document.documentElement.lang = l; window.dispatchEvent(new Event(EVT)); };
  const t = (s) => (lang === "en" ? EN[s] ?? s : s);
  return { lang, setLang, t };
}

export function LangToggle() {
  const { lang, setLang } = useLang();
  return (
    <div className="inline-flex border border-border rounded-sm overflow-hidden text-xs font-semibold" data-testid="lang-toggle">
      {["id", "en"].map((l) => (
        <button key={l} type="button" onClick={() => setLang(l)} data-testid={`lang-${l}-btn`} aria-pressed={lang === l}
          className={`px-2.5 py-1.5 uppercase transition-colors ${lang === l ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"}`}>
          {l}
        </button>
      ))}
    </div>
  );
}
